<template>
  <div>
    <div class="mb-5 d-flex justify-content-end" style="gap: 5px">
      <b-button
        v-if="localIsDetail && editId"
        variant="primary"
        @click="toggleEdit"
      >
        <i class="fa fa-pencil-square-o ml-2 text-white"></i>
        Update Data
      </b-button>
      <template v-if="!localIsDetail && editId">
        <b-button variant="primary" @click="onSaveSpalProcess" class="ml-2">
          <i class="fa fa-pencil-square-o ml-2 text-white"></i>
          Save Data
        </b-button>
        <b-button variant="outline-primary" @click="toggleEdit">
          Cancel Update
        </b-button>
      </template>
    </div>
    <div class="section-title">
      <h5>SPAL / CONTRACT</h5>
    </div>

    <b-row>
      <b-col
        md="12"
        class="mb-2 d-flex justify-content-between align-items-center"
      >
        <div></div>
        <b-button
          size="sm"
          variant="primary"
          v-if="!localIsDetail"
          @click="addSpalProcessRow"
        >
          <i class="fa fa-plus mr-1"></i>
          Add Spal Process Row
        </b-button>
      </b-col>
      <b-col md="12">
        <b-table bordered :items="tableItems" :fields="tableFields" responsive>
          <template #cell(title)="{ item }">
            <template v-if="!localIsDetail">
              <b-form-input
                v-model="item.title"
                required
                placeholder="Type SPAL title"
              />
            </template>
            <template v-else>
              <span class="font-semibold">{{ item.title || '-' }}</span>
            </template>
          </template>
          <template #cell(notes)="{ item }">
            <template v-if="!localIsDetail">
              <b-form-textarea v-model="item.notes" placeholder="Notes" />
            </template>
            <template v-else>
              <span>{{ item.notes || '-' }}</span>
            </template>
          </template>
          <template #cell(attachment)="{ item }">
            <template v-if="!localIsDetail">
              <b-form-file v-model="item.file" :required="required" />
            </template>
            <template v-else>
              <b-button
                v-if="item.attachment && item.attachment.length > 0"
                size="sm"
                variant="secondary"
                :href="`${apiUrl}/download/${item?.attachment?.[0]?.file_url?.replace('upload/', '')}`"
                target="_blank"
              >
                <i class="ri-download-line mr-1"></i>
                Download
              </b-button>
              <span v-else>-</span>
            </template>
          </template>
          <template #cell(fix)="{ item }">
            <template v-if="!localIsDetail">
              <b-form-checkbox switch v-model="item.is_fix_spal">
                {{ item.is_fix_spal ? 'Yes' : 'No' }}
              </b-form-checkbox>
            </template>
            <template v-else>
              <span class="font-semibold">
                {{ item.is_fix_spal ? 'Yes' : 'No' }}
              </span>
            </template>
          </template>
          <template #cell(comment)="{ index }">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="openCommentModal(index)"
            >
              <i class="fa fa-comments mr-1"></i>
              Comment
            </b-button>
          </template>
          <template #cell(actions)="{ index }">
            <b-button
              v-if="!localIsDetail"
              size="sm"
              variant="danger"
              @click="removeSpalProcessRow(index)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>

      <!-- Comment Modal -->
      <b-modal id="spal-comment-modal" :title="'Comments'" hide-footer>
        <b-table
          small
          bordered
          :items="commentItems"
          :fields="commentFields"
          responsive
        >
          <template #cell(comment)="{ item }">
            <span>{{ item.comment || '-' }}</span>
          </template>
          <template #cell(name)="{ item }">
            <span>{{ item.user_name || '-' }}</span>
          </template>
          <template #cell(date)="{ item }">
            <span>
              {{
                item.createdAt
                  ? moment(item.createdAt).format('DD/MM/YYYY')
                  : '-'
              }}
            </span>
          </template>
        </b-table>
      </b-modal>

      <b-col md="12 my-3">
        <div class="d-flex w-100">
          <button
            type="button"
            class="spal-tab"
            style="border-top-left-radius: 8px; border-bottom-left-radius: 8px"
            :class="{ active: activeTab === 'project_info' }"
            @click="activeTab = 'project_info'"
          >
            PROJECT INFORMATION
          </button>
          <button
            type="button"
            class="spal-tab"
            style="
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
            "
            :class="{ active: activeTab === 'customer' }"
            @click="activeTab = 'customer'"
          >
            CUSTOMER INFORMATION
          </button>
        </div>
      </b-col>

      <!-- <b-col md="12" class="mt-2">
        <b-row class="spal-tabs">
          <b-col md="6">
            <button
              type="button"
              class="spal-tab"
              :class="{ active: activeTab === 'project' }"
              @click="activeTab = 'project'"
            >
              PROJECT INFORMATION
            </button>
          </b-col>
          <b-col md="6">
            <button
              type="button"
              class="spal-tab"
              :class="{ active: activeTab === 'customer' }"
              @click="activeTab = 'customer'"
            >
              CUSTOMER INFORMATION
            </button>
          </b-col>
        </b-row>
      </b-col> -->

      <b-col md="12" class="mt-2">
        <b-row>
          <template v-if="activeTab == 'project_info'">
            <b-col md="6">
              <div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Project</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.projectName || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Company Name</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.companyName || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Fleet Ownership</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.fleetOwnership || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Fleet Type</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.fleetTypes || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Period</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.period || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Shipment Plan Number</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.shipmentPlanNumber || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Contract Type</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.contractType || '-' }}</span></span>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Term</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.term || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Port of Loading</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.pol || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Port of Discharging</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.pod || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Distance</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.distance || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Laycan</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.laycan || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Cargo Type</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.cargoType || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Total Plan QTY</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.totalPlanQty || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Remarks</span>
                  <span class="info-value">: <span class="fw-bold">{{ projectList?.remarks || '-' }}</span></span>
                </div>
              </div>
            </b-col>
          </template>
          <template v-else-if="activeTab == 'customer'">
            <b-col md="6">
              <div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Company Name</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.name || customerList?.customerActive?.account_name || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Website</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.web || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Email</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.email || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Country</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.country_id || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Province</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.province || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">City</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.city || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Address</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.address || '-' }}</span></span>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <div>
                <div class="mb-3 d-flex">
                  <span class="info-label">Nomor Pokok Wajib Pajak (NPWP)</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.npwp || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">NIB Number</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.nib || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">PIC Name</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.customer_contact?.[0]?.name || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">PIC Job Title</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.customer_contact?.[0]?.job_title || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">PIC Mobile Phone</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.customer_contact?.[0]?.mobile || '-' }}</span></span>
                </div>
                <div class="mb-3 d-flex">
                  <span class="info-label">PIC Email</span>
                  <span class="info-value">: <span class="fw-bold">{{ customerList?.customerActive?.customer_contact?.[0]?.email || customerList?.customerActive?.email || '-' }}</span></span>
                </div>
              </div>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { busdevActions } from '@src/Utils/helper'
import moment from 'moment'

export default {
  name: 'SpalSection',
  props: {
    value: {
      type: Object,
      default: () => ({ title: '', notes: '', file: null, fix: false }),
    },
    data: { type: Array, default: () => [] },
    project: { type: Array, default: () => [] },
    customer: { type: Object, default: () => {} },
    isDetail: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    editId: { type: [Number, null], default: null },
    selectedContractType: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      local: { ...this.value },
      activeTab: 'project_info',
      localIsDetail: false,
      saving: false,
      originalData: [],
      tableFields: [
        { key: 'title', label: 'SPAL Title' },
        { key: 'notes', label: 'Notes' },
        { key: 'attachment', label: 'Attachment' },
        { key: 'fix', label: 'Fix SPAL / Contract' },
        { key: 'comment', label: 'Comment' },
        { key: 'actions', label: 'Actions' },
      ],
      commentFields: [
        { key: 'comment', label: 'Comment' },
        { key: 'name', label: 'Name' },
        { key: 'date', label: 'Comment Date' },
      ],
      commentItems: [],
      selectedCommentRowIndex: null,
      apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,
    }
  },
  mounted() {
    this.localIsDetail = !!this.isDetail
  },
  computed: {
    tableItems() {
      return this.data
      // // In edit mode, single row bound to local
      // if (!this.localIsDetail) return [{ ...this.local }]

      // // In detail mode, show all rows from data.spal_process array (if any)
      // const arr = Array.isArray(this.data?.spal_process)
      //   ? this.data.spal_process
      //   : []
      // if (arr.length) {
      //   return arr.map((s) => ({
      //     id: s?.id,
      //     title: s?.title,
      //     notes: s?.notes,
      //     fileUrl: s?.fileUrl || s?.attachment_url || s?.url,
      //     fix: s?.is_fix_spal != null ? Boolean(s.is_fix_spal) : false,
      //   }))
      // }
      // // fallback to flat data structure if provided
      // return [
      //   {
      //     title: this.data?.title,
      //     notes: this.data?.notes,
      //     fileUrl: this.data?.fileUrl,
      //     fix: !!this.data?.fix,
      //   },
      // ]
    },
    projectList() {
      // Normalize array of {label, value} into a flat object for easy access
      if (Array.isArray(this.project)) {
        const map = {}
        this.project.forEach((item) => {
          if (!item || typeof item !== 'object') return
          const key = String(item.label || '')
            .trim()
            .toLowerCase()
          const val = item.value
          if (key === 'project') map.projectName = val
          else if (key === 'company name') map.companyName = val
          else if (key === 'fleet ownership') map.fleetOwnership = val
          else if (key === 'fleet type') map.fleetTypes = val
          else if (key === 'period') map.period = val
          else if (key === 'shipment plan number') map.shipmentPlanNumber = val
          else if (key === 'contract type') map.contractType = val
          else if (key === 'term') map.term = val
          else if (key === 'port of loading') map.pol = val
          else if (key === 'port of discharging') map.pod = val
          else if (key === 'distance') map.distance = val
          else if (key === 'laycan') map.laycan = val
          else if (key === 'cargo type') map.cargoType = val
          else if (key === 'total plan qty') map.totalPlanQty = val
          else if (key === 'remarks') map.remarks = val
        })
        return map
      }
      // If already object-like, return as is
      return this.project || {}
    },
    customerList() {
      return this.customer
    },
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        this.local = { ...v }
      },
    },
    local: {
      deep: true,
      handler(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    ...busdevActions,
    toggleEdit() {
      // Switching from detail -> edit: take a snapshot
      if (this.localIsDetail) {
        // going to edit mode
        this.originalData = JSON.parse(JSON.stringify(this.data || []))
      } else {
        // leaving edit mode (cancel/save) -> restore from snapshot on cancel scenario
        // In our UI, the Cancel Update button also calls toggleEdit. Detect cancel by presence of button context is tricky here,
        // but requirement says when cancel update pressed, rows added should be removed.
        // Since both Save and Cancel use same toggle, we rely on parent to persist on Save.
        // Therefore on leaving edit mode here, restore from snapshot.
        if (Array.isArray(this.originalData)) {
          // Replace array contents to keep reactivity
          this.data.splice(
            0,
            this.data.length,
            ...this.originalData.map((d) => ({ ...d }))
          )
        }
      }
      this.localIsDetail = !this.localIsDetail
    },
    addSpalProcessRow() {
      // push a new empty row to editable data source
      if (Array.isArray(this.data)) {
        this.data.push({
          title: '',
          notes: '',
          file: null,
          is_fix_spal: false,
        })
      }
    },
    openCommentModal(index) {
      this.selectedCommentRowIndex = index
      this.commentItems = (this.data[index] && this.data[index].comment) || []
      this.$bvModal && this.$bvModal.show('spal-comment-modal')
    },
    async removeSpalProcessRow(index) {
      if (!Array.isArray(this.data)) return
      if (index < 0 || index >= this.data.length) return
      const doDelete = async () => {
        const row = this.data[index]
        if (row && row.id) {
          try {
            const res = await this.deleteSpalProcess({ id: row.id })
            if (res && res.data?.status === true) {
              this.data.splice(index, 1)
              this.$bvToast &&
                this.$bvToast.toast('Row deleted', {
                  variant: 'success',
                  solid: true,
                })
            } else {
              this.$swal &&
                this.$swal('Oops!', 'Failed to delete row.', 'error')
            }
          } catch (e) {
            this.$swal &&
              this.$swal('Oops!', e.message || 'Failed to delete row.', 'error')
          }
        } else {
          this.data.splice(index, 1)
        }
      }

      if (this.$bvModal && this.$bvModal.msgBoxConfirm) {
        const ok = await this.$bvModal.msgBoxConfirm('Delete this row?', {
          okTitle: 'Delete',
          okVariant: 'danger',
          cancelTitle: 'Cancel',
        })
        if (ok) await doDelete()
      } else {
        await doDelete()
      }
    },
    async onSaveSpalProcess() {
      // Save per row: create if new, update if existing
      if (!Array.isArray(this.data) || !this.editId) return
      this.saving = true
      try {
        for (const row of this.data) {
          const formData = new FormData()
          formData.append('project_contract_id', this.editId)
          formData.append('title', row.title || '')
          formData.append('is_fix_spal', row.is_fix_spal ? 1 : 0)
          formData.append('notes', row.notes || '')

          if (row.file instanceof File) {
            formData.append('files', row.file)
          } else if (row.file && row.file.length) {
            for (let i = 0; i < row.file.length; i++)
              formData.append('files', row.file[i])
          }

          let res
          if (row.id) {
            res = await this.updateSpalProcess({ id: row.id, data: formData })
          } else {
            res = await this.createSpalProcess({ data: formData })
          }
          if (!res || res.data?.status !== true)
            throw new Error('Save SPAL Process failed')
          if (!row.id && res.data?.data?.id) {
            this.$set
              ? this.$set(row, 'id', res.data.data.id)
              : (row.id = res.data.data.id)
          }
        }

        this.$swal('Success!', 'Save Spal Process Success.', 'success')
        this.originalData = JSON.parse(JSON.stringify(this.data))
        this.localIsDetail = true
      } catch (e) {
        this.$swal('Oops!', e.message || 'Something went wrong.', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.font-semibold {
  font-weight: 600;
}
.spal-tabs {
  align-items: center;
}
.spal-tab {
  width: 100%;
  padding: 10px 12px;
  border-radius: 0px;
  border: 1px solid #334697;
  background: #fff;
  color: #334697;
  font-weight: 600;
}
.spal-tab.active {
  background: #334697;
  color: #fff;
  border-radius: 0px;
}
.tab-faded {
  opacity: 0.4;
}
.info-label {
  width: 30%;
  flex-shrink: 0;
}
.info-value {
  width: 70%;
  flex-grow: 1;
}
.fw-bold{
  font-weight:600;
}
</style>
